module.exports = __webpack_public_path__ + "static/media/windows.addae3d8.svg";